import { ref, computed } from 'vue';
import { useStockVO } from '@rebuild/hooks/useStockVO';
import i18n from '@/locales';

export const SUB_MODULES = ['main_index', 'balance_sheet', 'profit_statement', 'cash_flow_statement'];

export function useFinanceCommon() {
	const { isHKStock } = useStockVO();

	const activeDate = ref(3);
	const activePeriod = ref('A');

	// 日期范围选项
	const dateRange = computed(() => [
		{ value: 3, label: i18n.t('enterprise.lastThreeYear') },
		{ value: 5, label: i18n.t('enterprise.lastFiveYear') },
		{ value: 0, label: i18n.t('enterprise.all') }
	]);
	// 比较周期选项
	const getComparisonPeriod = computed(() =>
		isHKStock.value
			? [
					{
						value: 'S1',
						label: i18n.t('enterprise.interim')
					},
					{
						value: 'A',
						label: i18n.t('enterprise.annual')
					}
			  ]
			: [
					{
						value: 'Q1',
						label: i18n.t('enterprise.first-quarter')
					},
					{
						value: 'S1',
						label: i18n.t('enterprise.interim')
					},
					{
						value: 'Q3',
						label: i18n.t('enterprise.third-quarter')
					},
					{
						value: 'A',
						label: i18n.t('enterprise.annual')
					}
			  ]
	);

	// 处理数据切片的通用方法
	const sliceDataByDate = (data, lastDate) => {
		if (!data || !Array.isArray(data)) return [];
		return data.slice(0 - lastDate).map(ele => ({
			...ele,
			year: ele.year.toString()
		}));
	};

	// 处理 tabs 数组的通用方法
	const processTabs = tabData => {
		if (!tabData || !Array.isArray(tabData)) return [];
		return tabData
			.filter(ele => ele.isPublish)
			.map(ele => {
				ele.label = ele.name;
				ele.value = ele.id;
				return ele;
			});
	};

	return {
		activeDate,
		activePeriod,
		dateRange,
		getComparisonPeriod,

		sliceDataByDate,
		processTabs
	};
}
